import { BigNumber, Long } from "shared/cubiq-model-multi-asset";
import { OEPanelGammaLeg } from "./models/oe-panel-gamma-leg.model";
import { OEPanelGammaViewModel } from "./models/oe-panel-gamma-view.model";

export class GammaUtils {
  public static getPairEntryPrecision(ccyPair: any, inverted: boolean): number {
    let decs: number = inverted ? ccyPair.spotInvertDecimalsQty : ccyPair.limitEntrySpotDecimals;
    return decs;
  }

  public static getSpotPrecision(ccyPair: any, inverted: boolean): number {
    let decs: number = inverted ? ccyPair.spotInvertDecimalsQty : ccyPair.rateDecimalsQty;
    return decs;
  }

  public static getPipsIncrementPart(
    ccyPair: any,
    inverted: boolean,
    deltaParam: BigNumber,
  ): BigNumber {
    let entryDecs: number = this.getPairEntryPrecision(ccyPair, inverted);
    let spotPrecision: number = entryDecs - (entryDecs - this.getSpotPrecision(ccyPair, inverted));

    let basicIncrement: string = (deltaParam.toNumber() * Math.pow(10, -spotPrecision)).toFixed(
      entryDecs,
    );

    let deltaIncrement: BigNumber = new BigNumber(basicIncrement).decimalPlaces(entryDecs); //.00025
    return deltaIncrement;
  }

  public static searchAbove(array: OEPanelGammaLeg[], target: BigNumber): number {
    let i: number = 0;
    for (i; i < array.length; i++) {
      if (target.toNumber() > array[i].rate.toNumber()) {
        return i;
      }
    }
    return array.length;
  }

  public static searchBelow(array: OEPanelGammaLeg[], target: BigNumber) {
    let i: number = 0;
    for (i; i < array.length; i++) {
      if (target.toNumber() > array[i].rate.toNumber()) {
        return i;
      }
    }
    return array.length;
  }

  public static assertNotNullEmpty(array: OEPanelGammaLeg[]): boolean {
    if (array != null && array.length > 0) {
      return true;
    }
    return false;
  }

  public static removeFromArray(legs: Array<OEPanelGammaLeg>, value: OEPanelGammaLeg): void {
    legs.forEach((element, index) => {
      if (element.legId == value.legId) legs.splice(index, 1);
    });
  }

  /*one pip delta keeps you 1 pip off the higher leg..
    min pips keeps you the pair defined amout away from lower leg.
  */
  public static calculateRateBoundaries(gammaLadderModel: OEPanelGammaViewModel) {
    if (GammaUtils.assertNotNullEmpty(gammaLadderModel.gammaLegsAbove)) {
      let i: number = gammaLadderModel.gammaLegsAbove.length - 1;
      for (i; i >= 0; i--) {
        let currentLeg: OEPanelGammaLeg;
        let previousLeg: OEPanelGammaLeg;
        let nextLeg: OEPanelGammaLeg;
        if (i == gammaLadderModel.gammaLegsAbove.length - 1) {
          previousLeg = new OEPanelGammaLeg();
          previousLeg.rate = gammaLadderModel.midRate[0].value;
        } else {
          previousLeg = gammaLadderModel.gammaLegsAbove[i + 1];
        }

        currentLeg = gammaLadderModel.gammaLegsAbove[i];
        nextLeg = gammaLadderModel.gammaLegsAbove[i - 1];

        let minPips: Long = gammaLadderModel.currencyPair.model.minimumGammaDeltaPips;
        if (minPips == null) {
          minPips = new Long(10);
        }
        let minDelta: BigNumber = GammaUtils.getPipsIncrementPart(
          gammaLadderModel.currencyPair.model,
          gammaLadderModel.currencyPair.inverted,
          new BigNumber(minPips.toString()),
        );
        //let onePipDelta: BigNumber = gammaLadderModel.getPipsIncrementPart(new BigNumber(1));
        let minRate: BigNumber = previousLeg.rate.plus(minDelta);

        let maxRate: BigNumber = null;
        if (nextLeg != null) {
          maxRate = nextLeg.rate.minus(minDelta);
          currentLeg.maxRate = maxRate;
        } else {
          maxRate = new BigNumber(Number.MAX_SAFE_INTEGER);
          currentLeg.maxRate = maxRate;
        }
        currentLeg.minRate = minRate;
      }
    }
    if (GammaUtils.assertNotNullEmpty(gammaLadderModel.gammaLegsBelow)) {
      let i: number = 0;
      for (i; i < gammaLadderModel.gammaLegsBelow.length; i++) {
        let currentLeg: OEPanelGammaLeg;
        let previousLeg: OEPanelGammaLeg;
        let nextLeg: OEPanelGammaLeg;
        if (i == 0) {
          previousLeg = new OEPanelGammaLeg();
          previousLeg.rate = gammaLadderModel.midRate[0].value;
        } else {
          previousLeg = gammaLadderModel.gammaLegsBelow[i - 1];
        }

        currentLeg = gammaLadderModel.gammaLegsBelow[i];
        nextLeg = gammaLadderModel.gammaLegsBelow[i + 1];

        let minPips: Long = gammaLadderModel.currencyPair.model.minimumGammaDeltaPips;
        if (minPips == null) {
          minPips = new Long(10);
        }
        let minDelta: BigNumber = GammaUtils.getPipsIncrementPart(
          gammaLadderModel.currencyPair.model,
          gammaLadderModel.currencyPair.inverted,
          new BigNumber(minPips.toString()),
        );

        // let onePipDelta: BigNumber = this.gammaLadderModel.getPipsIncrementPart(new BigNumber(1));
        let maxRate: BigNumber = previousLeg.rate.minus(minDelta);
        let minRate: BigNumber;
        currentLeg.maxRate = maxRate;
        if (nextLeg != null) {
          minRate = nextLeg.rate.plus(minDelta);
        } else {
          minRate = new BigNumber(0);
        }
        currentLeg.minRate = minRate;
        currentLeg.maxRate = maxRate;
      }
    }
  }
}
